import { render, staticRenderFns } from "./StudentDeliveryAddress.vue?vue&type=template&id=2d16a05a&scoped=true&"
import script from "./StudentDeliveryAddress.vue?vue&type=script&lang=js&"
export * from "./StudentDeliveryAddress.vue?vue&type=script&lang=js&"
import style0 from "./StudentDeliveryAddress.vue?vue&type=style&index=0&id=2d16a05a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d16a05a",
  null
  
)

export default component.exports